import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../constants/common'
import { LOCAL_STORAGE_REAUTH_EMAIL } from '../../../../constants/storage'
import { setStorageItem } from '../../../../utils/storage'
import { EmailReconnectAccountsModal } from '../../EmailReconnectAccountsModal'

import { EMAILS_NOTIFICATION_NEED_RECONNECT_ACCOUNT } from './useCheckEmailAccount.constants'
import { getAccountsList, getReauthValues } from './useCheckEmailAccount.utils'

export function useCheckEmailAccount({
  accounts,
  handleAddNotification,
  handleRemoveNotification,
  setModal,
}) {
  const { t } = useTranslation()

  const accountsList = getAccountsList(accounts)

  function handleClose() {
    setModal(null)
  }

  function handleReconnect() {
    setModal(
      <EmailReconnectAccountsModal
        accounts={accountsList}
        onClose={handleClose}
      />
    )
  }

  const showReauth = getReauthValues()

  useEffect(() => {
    if (showReauth && accountsList.length > 0) {
      handleReconnect()
      setStorageItem(LOCAL_STORAGE_REAUTH_EMAIL, Date.now())
    }
  }, [accountsList])

  useEffect(() => {
    if (accountsList.length > 0) {
      handleAddNotification({
        actions: [
          {
            callback: handleReconnect,
            text: t('Notification.ConnectEmailLinkKey'),
          },
        ],
        id: EMAILS_NOTIFICATION_NEED_RECONNECT_ACCOUNT,
        text: t('Error.ConnectionInterruptedNotificationErrorKey'),
        type: NOTIFICATION_TYPE.error,
      })
    }

    if (accountsList.length === 0) {
      handleRemoveNotification(EMAILS_NOTIFICATION_NEED_RECONNECT_ACCOUNT)
    }
  }, [accountsList])
}
